import React from 'react'
import {
  Calendar,
  Badge,
  Button,
  Modal,
  Tag,
  Table,
  DatePicker,
  Row,
  Col,
  Spin,
  Empty,
  Radio,
} from 'antd'
import { Moment } from '../../../helpers'
import { InformfixService, JobService } from '../../../services'
import { Config } from '../../../config'
import { JobStatus } from '../JobStatus'
import { JobDateTime } from '../JobDateTime'
import { JobDueDate } from '../JobDueDate'
import { JobCalendarItem } from '../JobCalendarItem'
import JobForm from '../job-form'
import local from 'antd/es/date-picker/locale/th_TH'
import './style.scss'
import {
  PlusCircleOutlined,
  ReloadOutlined,
  SaveOutlined,
} from '@ant-design/icons'

function getMonthData(value) {
  console.log('getMonthData', Moment(value).format('LL'))
  if (value.month() === 8) {
    return 1394
  }
}

function getListData(value) {
  let listData
  console.log('getListData', Moment(value).format('LL'))
  switch (value.date()) {
    case 8:
      listData = [
        { type: 'warning', content: 'This is warning event.', bg: 'red' },
        { type: 'success', content: 'This is usual event.', bg: 'green' },
      ]
      break
    case 26:
      listData = [
        { type: 'warning', content: 'This is warning event.', bg: 'red' },
        { type: 'success', content: 'This is usual event.', bg: 'green' },
      ]
      break
    case 10:
      listData = [
        { type: 'warning', content: 'This is warning event.' },
        { type: 'success', content: 'This is usual event.' },
        { type: 'error', content: 'This is error event.' },
      ]
      break
    case 15:
      listData = [
        { type: 'warning', content: 'น้ำรั่ว' },
        { type: 'success', content: 'ทาสี' },
        { type: 'error', content: 'เปลี่ยนหลอดไฟ 1.' },
        { type: 'error', content: 'This is error event 2.' },
        { type: 'error', content: 'This is error event 3.' },
        { type: 'error', content: 'This is error event 4.' },
      ]
      break
    default:
  }
  return listData || []
}

const IconText = ({ type, text }) => (
  <span>
    {/* <Icon type={type} style={{ marginRight: 8 }} /> */}
    {text}
  </span>
)

class CalendarEvent extends React.Component {
  state = {
    loading: false,
    showModalView: false,
    currentViewDate: null,
    currentJobs: [],
    listJobStatus: [],
    listJobs: [],
    currentDate: Moment(),
    date: new Date(),
    currentSelectedDate: Moment(),
    todayJobs: [],
    rangeDate: [],
    isComplete: 'no',
    visibleModalCreat: false,
    calendarJobType:
      this.props.jobComplete !== undefined ? this.props.jobComplete : 'no',
  }
  UNSAFE_componentWillMount() {
    const now = Moment()
    this.getJobByYearMonth(now)
    // this.getJobStatus()
  }
  componentDidMount() {
    // const today = Moment()
    // this.loadTodayJob(today)
  }

  onChangeCalendayJobType = (e) => {
    console.log(e.target.value)
    this.setState({
      calendarJobType: e.target.value,
    })
    setTimeout(() => {
      this.reload()
    }, 200)
  }

  getJobByYearMonth = (date) => {
    const formatdate = Moment(date).format('YYYY-MM-DD')
    const params = {
      date: formatdate,
      myjob: this.props.onlyOwner ? 'yes' : '',
      complete: this.state.calendarJobType,
    }
    this.setState({
      loading: true,
    })
    JobService.byYearMonth(params)
      .then((rs) => {
        const jobs = rs.data
        if (jobs) {
          this.setState({
            currentSelectedDate: date,
            listJobs: jobs,
            loading: false,
          })
          let currentJobs = []
          jobs.map((job, key) => {
            const sDate = Moment(job.start_time).format('YYYY-MM-DD')
            const eDate = Moment(job.end_time).format('YYYY-MM-DD')
            const cDate = Moment(date).format('YYYY-MM-DD')
            const inRangeDate = Moment(formatdate).isBetween(
              sDate,
              eDate,
              'days',
            )
            if (cDate == sDate || cDate == eDate) {
              currentJobs.push(job)
            }
          })
          this.setState({
            todayJobs: currentJobs,
            loading: false,
          })
        }
      })
      .catch((err) => {
        this.setState({
          loading: false,
        })
      })
  }

  // /**
  //  *
  //  */
  // getJobByDate = (date) => {
  //   this.setState({ showModalView: false, currentJobs: [], loading: true })
  //   let params = {
  //     date: date,
  //     myjob: this.props.onlyOwner ? 'yes' : '',
  //   }

  //   JobService.bydate(params).then((rs) => {
  //     if (rs) {
  //       const items = rs.data
  //       this.setState({
  //         currentJobs: items,
  //       })
  //     }
  //   })
  // }

  createNewEvent = () => {
    this.setState({
      visibleModalCreat: true,
    })
    console.log('showModalCreate', this.state.visibleModalCreat)
  }

  loadTodayJob = (date) => {
    const today = Moment(date).format('YYYY-MM-DD')
    this.setState({
      currentSelectedDate: date,
      todayJobs: [],
    })
    const params = {
      date: today,
      myjob: this.props.onlyOwner ? 'yes' : '',
    }

    JobService.bydate(params).then((rs) => {
      if (rs) {
        const items = rs.data
        this.setState({
          todayJobs: items,
        })
      }
    })
  }

  hideModalView = () => {
    this.setState({
      showModalView: false,
      currentViewDate: null,
    })
  }

  /**
   *
   */
  getJobs = (id) => {
    this.setState({ currentJobs: [], loading: true })
    InformfixService.getJobs(id).then((rs) => {
      if (rs) {
        const items = rs.data['data']
        this.setState({
          currentJobs: items,
        })
      }
    })
  }

  showJobBydate = (date) => {
    this.setState({
      showModalView: false,
      currentViewDate: date,
      currentJobs: [],
    })
    const setdate = Moment(date).format('YYYY-MM-DD')
    this.setState({ showModalView: false, currentJobs: [], loading: true })
    JobService.bydate(setdate).then((rs) => {
      if (rs) {
        const items = rs.data
        if (items.length > 0) {
          this.setState({
            currentJobs: items,
            showModalView: true,
          })
        }
      }
    })
  }

  onChange = (value) => {
    if (value.isValid()) {
      this.getJobByYearMonth(value)
      // this.loadTodayJob(value)
    }
  }

  onSelect = (value) => {
    console.log('onSelect', Moment(value).format('YYYY-MM-DD'))
  }

  onStartJob = (data) => {
    this.reload()
  }
  onSendJob = (data) => {
    this.reload()
  }

  reload = () => {
    const formatdate = this.state.currentSelectedDate
    if (formatdate.isValid()) {
      this.getJobByYearMonth(formatdate)
    }
  }

  render() {
    const {
      currentViewDate,
      showModalView,
      listJobs,
      todayJobs,
      currentJobs,
      loading,
    } = this.state

    const monthCellRender = (value) => {
      let jobs = this.state.listJobs
      let currentMont = value.format('M')
      let num = 0
      if (jobs) {
        jobs.map((item, key) => {
          if (currentMont == Moment(item.start_time).format('M')) {
            num += 1
          }
        })
      }

      return num > 0 ? (
        <div className="notes-month">
          <section>
            <Tag>{num} รายการ</Tag>
          </section>
          {/* <span>Backlog number</span> */}
        </div>
      ) : null
    }

    /**
     * แสดงต้วเลขวันที่
     * @param {*} value
     * @returns
     */
    const dateCellRender = (value) => {
      // console.log('date', value.date())
      const listData = this.state.listJobs
      const formatdate = Moment(value).format('YYYY-MM-DD')
      let num = 0
      // console.log(formatdate)
      if (listData) {
        listData.map((item, key) => {
          if (formatdate == Moment(item.start_time).format('YYYY-MM-DD')) {
            num += 1
          }
        })
      }
      return (
        <React.Fragment>
          <Badge count={num} />
          {/* <ul className="events">
          {listJobs.map((item, index) =>
            Moment(item.start_time).format('YYYY-MM-DD') == formatdate ? (
              <li
                onClick={() =>
                  this.showJobBydate(
                    Moment(item.start_time).format('YYYY-MM-DD'),
                  )
                }
                key={index}
                style={{
                  cursor: 'pointer',
                  color: Config.job.jobStatus
                    ? Config.job.jobStatus[item.job_status].background
                    : '',
                }}
              >
                {item.list}
              </li>
            ) : (
              ''
            ),
          )}
          </ul> */}
        </React.Fragment>
      )
    }

    // แสดงวันที่
    const showFormatDate = (datetime) => {
      let date = Moment(datetime)
      if (date.isValid()) {
        return date.format('ll')
      } else {
        return
      }
    }
    // แสดงเวลา
    const showFormatTime = (datetime) => {
      const time = Moment(datetime)
      if (time.isValid()) {
        return (
          <Tag size="small" color="#383838">
            {time.format('LT')} น.
          </Tag>
        )
      } else {
        return
      }
    }

    // ชื่อช่าง
    const technicianName = (job) => {
      if (job.technicians && job.technicians.length > 0) {
        let name = ''
        let names = []
        job.technicians.map((v, key) => {
          if (v.technician) {
            if (v.technician) {
              names.push(
                <Tag color="" key={v.technician.id + '-' + key}>
                  {v.technician.firstname}
                </Tag>,
              )
            }
          }
        })
        return names
      }
    }

    // แสดงวันที่สร้าง
    const showTimeCreatedAt = (datetime) => {
      let date = Moment.unix(datetime)
      if (date.isValid()) {
        return date.format('lll')
      } else {
        return
      }
    }

    const showDetail = (record) => {
      return (
        <div
          key={'kdskfsdgjrff' + record.id}
          style={{
            marginLeft: 20,
            fontSize: '12px',
          }}
        >
          {record.informFix ? (
            <div>
              <IconText
                key={'icon-project' + record.id}
                type="bank"
                text={record.informFix.project.name}
              />
            </div>
          ) : null}

          {record.informFix ? (
            <div>
              <IconText
                key={'icon-home' + record.id}
                type="home"
                text={'บ้านเลขที่ ' + record.informFix.home.home_no}
              />
              {'  '}
              <IconText
                key={'icon-planno' + record.id}
                type="home"
                text={' แปลง ' + record.informFix.home.plan_no}
              />
            </div>
          ) : null}
          {record.technicians && record.technicians.length > 0 ? (
            <div>
              <IconText
                key={'thcidksgfsdf' + record.id}
                type="user"
                text={record.technicians ? technicianName(record) : null}
              />
            </div>
          ) : null}
          {record.created_at > 0 ? (
            <div>
              <IconText
                key={'hptpmlreome' + record.id}
                type="calendar"
                text={
                  record.created_at
                    ? '' + showTimeCreatedAt(record.created_at)
                    : '-'
                }
              />
            </div>
          ) : null}
        </div>
      )
    }

    const columns = [
      {
        titl: 'ID',
        key: 'id',
        dataIndex: 'id',
      },
      {
        title: 'หมวดหมู่',
        key: 'group.name',
        dataIndex: 'group.name',
        render: (group, record) => {
          return <Tag>{record.group ? record.group.name : null}</Tag>
        },
      },
      {
        title: 'รายการ',
        dataIndex: 'list',
        key: 'subject',
        render: (list, record) => {
          return (
            <React.Fragment>
              <div>
                <strong>{list}</strong>
              </div>
              <small>{record.description ? record.description : null}</small>

              {showDetail(record)}
            </React.Fragment>
          )
        },
      },
      {
        title: 'ตั้งแต่',
        dataIndex: 'start_time',
        key: 'start_time',
        render: (start_time, record) => {
          return (
            <JobDateTime datetime={start_time} jobStatus={record.job_status} />
          )
        },
      },
      {
        title: 'ถึง',
        dataIndex: 'end_time',
        key: 'end_time',
        render: (end_time, record) => {
          return (
            <JobDateTime datetime={end_time} jobStatus={record.job_status} />
          )
        },
      },
      {
        title: 'สถานะ',
        dataIndex: 'job_status',
        key: 'job_status',
        render: (job_status, record) =>
          job_status ? (
            <React.Fragment>
              <div>
                <JobStatus
                  name={record.jobStatusName}
                  statusId={record.job_status}
                />
              </div>
              <div style={{ marin: 3, textAlign: 'center' }}>
                <JobDueDate data={record} />
              </div>
            </React.Fragment>
          ) : null,
      },
    ]

    const showTodayTitle = () => {
      const date = this.state.currentSelectedDate
      if (date.isValid()) {
        return date.format('LL')
      }
      return null
    }
    const showThisMonthTitle = () => {
      const date = this.state.currentSelectedDate
      if (date.isValid()) {
        return date.format('MMMM YYYY')
      }
      return null
    }

    const colDate = { xs: 24, sm: 8, md: 8, lg: 10, xl: 6 }
    const colDetail = { xs: 24, sm: 16, md: 16, lg: 14, xl: 18 }
    return (
      <React.Fragment>
        <Row gutter={[8, 8]}>
          <Col xs={24} sm={24} md={24} lg={8} xl={6}>
            <div
              style={{
                margin: 3,
              }}
            >
              <Radio.Group
                optionType="button"
                onChange={this.onChangeCalendayJobType}
                defaultValue={this.state.calendarJobType}
                buttonStyle="default"
                size="small"
              >
                <Radio value="no">อยู่ระหว่างดำเนินการ</Radio>
                <Radio value="yes">เสร็จแล้ว</Radio>
              </Radio.Group>
            </div>
            <Calendar
              fullscreen={false}
              // style={{
              //   backgroundColor: '#ffffff',
              // }}
              dateCellRender={dateCellRender}
              monthCellRender={monthCellRender}
              onSelect={(date) => this.onSelect(date)}
              onChange={(date) => this.onChange(date)}
              mode="month"
              locale={local}
            />
          </Col>
          <Col xs={24} sm={24} md={24} lg={16} xl={18}>
            <p>
              {showTodayTitle()}
              <Button
                style={{ marginLeft: 10 }}
                onClick={() => this.reload()}
                icon={<ReloadOutlined />}
                size="small"
              >
                รีโหลด
              </Button>
              <Button
                size="small"
                icon={<PlusCircleOutlined />}
                style={{
                  marginLeft: 10,
                  // backgroundColor: 'green',
                  // color: '#ffffff',
                }}
                onClick={() => this.createNewEvent()}
              >
                เพิ่มงานใหม่
              </Button>
            </p>
            {loading ? (
              <div className="loading-container">
                <Spin size="large" spinning={true} />
              </div>
            ) : (
              ''
            )}
            {todayJobs.length > 0 ? (
              <>
                <div style={{ marginbottom: 7, color: 'red' }}>
                  * การบันทึกลายเซ็น ควรหมุนหน้าจอเป็นแนวนอน ก่อนที่จะกด ปุ่ม
                  [ส่งงาน] เพื่อให้แป้นวาดลายเซ็นได้สัดส่วนที่พอดี
                </div>
                {todayJobs && todayJobs.length > 0 ? (
                  todayJobs.map((job, index) => (
                    <JobCalendarItem
                      job={job}
                      key={index}
                      seq={index + 1}
                      onStartJob={this.onStartJob}
                      onSendJob={this.onSendJob}
                    />
                  ))
                ) : (
                  <Empty />
                )}
              </>
            ) : null}
          </Col>
        </Row>

        {showModalView && currentViewDate ? (
          <Modal
            style={{ top: 1 }}
            title={
              'วันที่ ' +
              (currentViewDate
                ? Moment(currentViewDate)
                    .utc(7)
                    .format('LL')
                : null)
            }
            currentDate={this.state.currentViewDate}
            open={this.state.showModalView}
            onCancel={this.hideModalView}
            onOk={this.hideModalView}
            width={900}
            bodyStyle={{
              overflowY: 'scroll',
              height: 300,
            }}
          >
            {currentJobs && currentJobs.length > 0 ? (
              <Table
                key="table-jobs"
                dataSource={currentJobs}
                columns={columns}
                pagination={false}
              />
            ) : null}
          </Modal>
        ) : null}
        {this.state.visibleModalCreat ? (
          <JobForm
            visible={this.state.visibleModalCreat}
            onCancel={() => {
              this.setState({
                visibleModalCreat: false,
              })
            }}
            onCreated={(data) => {
              console.log('onCreated', data)
              this.setState({
                visibleModalCreat: false,
              })
              this.reload()
            }}
          />
        ) : null}
      </React.Fragment>
    )
  }
}

export default CalendarEvent
